import type { BlockPlugin } from "./types";

/**
 * Registry of block types. The engine looks up each `type`'s plugin HERE;
 * adding a new type is `registry.register(plugin)`, without touching the
 * engine. This is the piece that makes the platform generic ("learn anything").
 */
export class BlockRegistry {
  private readonly plugins = new Map<string, BlockPlugin>();

  /** Registers a plugin. Throws if the `type` already exists (avoids overwriting types). */
  register(plugin: BlockPlugin): this {
    if (this.plugins.has(plugin.type)) {
      throw new Error(`BlockRegistry: tipo duplicado "${plugin.type}"`);
    }
    this.plugins.set(plugin.type, plugin);
    return this;
  }

  /** Registers several at once. */
  registerAll(plugins: readonly BlockPlugin[]): this {
    for (const p of plugins) {
      this.register(p);
    }
    return this;
  }

  get(type: string): BlockPlugin | undefined {
    return this.plugins.get(type);
  }

  has(type: string): boolean {
    return this.plugins.has(type);
  }

  /** List of registered types (for the authoring editor: "insert block"). */
  types(): string[] {
    return [...this.plugins.keys()];
  }
}
